var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.117 1.166a.19.19 0 0 0-.234 0l-3.937 3.15a.19.19 0 0 0-.071.147v5.264c0 .104.084.188.188.188h2.062V5.977a.56.56 0 0 1 .563-.562h2.625a.56.56 0 0 1 .562.562v3.938h2.063a.19.19 0 0 0 .187-.188V4.462a.19.19 0 0 0-.07-.146zM5.18.288a1.31 1.31 0 0 1 1.64 0l3.937 3.15c.312.249.493.626.493 1.025v5.264a1.31 1.31 0 0 1-1.312 1.313H7.312a.563.563 0 0 1-.562-.563V6.54h-1.5v3.937a.56.56 0 0 1-.562.563H2.063A1.31 1.31 0 0 1 .75 9.727V4.462c0-.398.182-.775.493-1.024z",
    clipRule: "evenodd"
  })));
};
export default SvgHome;